import React from 'react';
import TranslationStore from '../../../stores/translations_store';
import getTranslatedText from '../../../helper/get_translated_text';

/**
 * @attr translationKey ->
 * @attr targetProperty ->
 * @attr placeholder (Optional) ->
 */
class TranslationContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            translationText: TranslationContainer._getTranslationText(this.props)
        };
    }

    componentDidMount() {
        TranslationStore.addListener(() => {
            const newTranslationText = TranslationContainer._getTranslationText(this.props);

            if (newTranslationText !== this.state.translationText) {
                this.setState({
                    translationText: newTranslationText
                });
            }
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const newTranslationText = TranslationContainer._getTranslationText(nextProps);

        if (newTranslationText !== this.state.translationText) {
            this.setState({ translationText: newTranslationText });
        }
    }

    render() {
        return React.cloneElement(this.props.children, {
            [this.props.targetProperty]: this.state.translationText
        });
    }

    static _getTranslationText(props) {
        if (props.transform) {
            return props.transform(
                getTranslatedText(props.translationKey, props.placeholder)
            );
        } else {
            return getTranslatedText(props.translationKey, props.placeholder);
        }
    }
}

export default TranslationContainer;